import useRemoveOverlay from "@hooks/useRemoveOverlay";
import { ResponseType } from "@sphtech/web2-core/ssr";
import type { ReactElement } from "react";

export function meta() {
  return [{ title: "Page not found" }];
}

export default function NotFound(): ReactElement {
  useRemoveOverlay();
  return (
    <>
      <div className="flex flex-col items-center mt-[160px]">
        <h1 className="text-md text-black-100 lg:text-lg">
          Sorry, the page you visited no longer exists.
        </h1>
        <p className="text-md text-black-100 lg:text-lg">
          Please visit our{" "}
          <span>
            <a href="/" className="underline text-blue-400">
              Home Page
            </a>
          </span>
        </p>
      </div>
    </>
  );
}

export const loader = () => {
  return {
    type: ResponseType.SUCCESS, // Required field
    statusCode: 200, // Required field
    payload: {}, // Required field
    dependentPaths: [],
  };
};
